import * as React from "react";
import { SVGProps } from "react";

const DeleteRed = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 20.207 20.207"
    ref={props.svgref}
    {...props}
  >
    <g data-name="Group 4501">
      <g data-name="Group 652" transform="translate(.8 .8)">
        <circle
          data-name="Ellipse 7049"
          cx={9.303}
          cy={9.303}
          r={9.303}
          fill="#e58f8f"
          stroke="#e58f8f"
          strokeWidth={2}
        />
      </g>
      <g data-name="Group 653">
        <path
          data-name="Line 214"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeWidth={1.2}
          d="M5.856 10.431h8.816"
        />
      </g>
    </g>
  </svg>
);

export default DeleteRed;
